import { Injectable, Injector } from '@angular/core';
import { FrameContext, Entity } from '@farris/devkit';
import { BefRepository } from '@farris/bef';
import { FormLoadingService } from './form-loading/form-loading.service';
import { RuntimeFrameworkService } from './rtf-service';
import { tap } from 'rxjs/operators';
import { Observable, of, EMPTY } from 'rxjs';
import { BasePathService } from '@farris/rtf';
// tslint:disable: max-line-length
@Injectable()
export class DiscussionGroupService {
  /**
   * å®ä½ä»åº
   */
  private get repository(): BefRepository<Entity> {
    return this.frameContext.repository as BefRepository<Entity>;
  }
  /**
   * å½ä»¤åæ°
   */
  private get params() {
    return this['context'] && this['context']['eventParam'] || {};
  }
  constructor(private injector: Injector, private frameContext: FrameContext, private loadingService: FormLoadingService, private runtimeFrameworkService: RuntimeFrameworkService) {
  }

  public addComment(id?: string, summary?: string, configId?: string, text?: string, visibility?: string, parentId?: string): Observable<any> {
    id = id || this.frameContext && this.frameContext.bindingData.list.currentId || null;
    if (!id) {
      return EMPTY;
    }
    const params = this.buildAddCommentParam(id, text, parentId, summary, visibility, configId);
    const restService = this.repository.restService;
    const url = BasePathService.convertPath('/api/runtime/comment/v1.0/bill-comment/comment');
    const requestInfo = restService.buildRequestInfo();
    const options = {
      body: {
        requestInfo,
        ...params
      }
    };
    this.loadingService.show();
    return restService.invoke(url, 'POST', null, options).pipe(
      tap(() => {
        this.loadingService.hide();
      })
    );
  }
  /**
   * æ¥è¯¢è¯è®º
   * @param id id
   */
  public queryComments(id: string, configId: string, pageIndex?: number | null, pageSize?: number | null): Observable<any> {
    id = id || this.frameContext && this.frameContext.bindingData.list.currentId || null;
    if (!id) {
      return EMPTY;
    }

    const restService = this.repository.restService;

    const url = this.buildQueryCommentsUrl(id, pageIndex, pageSize, configId);
    this.loadingService.show();
    return restService.invoke(url, 'GET').pipe(
      tap(() => {
        this.loadingService.hide();
      })
    );
  }
  /**
   * æ¥è¯¢ææé¨é¨ä¿¡æ¯
   */
  public queryAllOrgs() {
    const restService = this.repository.restService;
    const url = BasePathService.convertPath('/api/runtime/sys/v1.0/sysOrgs?param={"layer":"1"}');
    this.loadingService.show();
    return restService.invoke(url, 'GET').pipe(
      tap(() => {
        this.loadingService.hide();
      })
    );
  }
  /**
   * æ¥è¯¢å¸¸ç¨@ç¨æ·
   * @param pageIndex
   * @param pageSize
   */
  public queryFrequentAtUsers(pageIndex?: number | null, pageSize?: number | null) {
    const restService = this.repository.restService;
    const url = this.buildQueryFrequentAtUsersUrl(pageIndex, pageSize);
    this.loadingService.show();
    return restService.invoke(url, 'GET').pipe(
      tap(() => {
        this.loadingService.hide();
      })
    );
  }
  /**
   * è·åatç¨æ·åè¡¨
   * @param user ç¨æ·ç¼å·æèç¨æ·åç§°ï¼è¿æ»¤ä½¿ç¨ï¼
   * @param pageIndex pageIndex
   * @param pageSize pageSize
   */
  public queryAtUsers(user?: string, pageIndex?: number | null, pageSize?: number | null) {
    const restService = this.repository.restService;
    const url = this.buildQueryAtUsersUrl(user, pageIndex, pageSize);
    this.loadingService.show();
    return restService.invoke(url, 'GET').pipe(
      tap(() => {
        this.loadingService.hide();
      })
    );
  }
  /**
   * æé è·åè¯è®ºåè¡¨çurl
   * @param id id
   */
  private buildQueryCommentsUrl(id: string, pageIndex: number | null, pageSize: number | null, configId: string) {
    if (typeof pageIndex === 'undefined' || pageIndex === null) {
      pageIndex = this.params.pageIndex || 0;
    }
    if (typeof pageSize === 'undefined' || pageSize === null) {
      pageSize = this.params.pageSize || 10;
    }
    const serverUri = this.repository.serverUri;
    // const funcId = this.runtimeFrameworkService && this.runtimeFrameworkService.funcId || '';
    return BasePathService.convertPath(`/api/runtime/comment/v1.0/bill-comment/comment/byBill?configId=${configId}&billId=${id}&pageSize=${pageSize}&pageIndex=${pageIndex}`);
  }
  /**
   * æé è·å@ç¨æ·url
   */
  private buildQueryAtUsersUrl(user?: string, pageIndex?: number | null, pageSize?: number | null) {
    const params: string[] = [];
    if (typeof pageIndex === 'undefined' || pageIndex === null) {
      pageIndex = this.params.pageIndex || 0;
    }
    if (typeof pageSize === 'undefined' || pageSize === null) {
      pageSize = this.params.pageSize || 1000;
    }
    if (user) {
      params.push(`param=${user}`);
    }
    params.push(`pageSize=${pageSize}`);
    params.push(`pageIndex=${pageIndex}`);
    return BasePathService.convertPath(`/api/runtime/comment/v1.0/bill-comment/atUser?${params.join('&')}`);
  }
  private buildQueryFrequentAtUsersUrl(pageIndex?: number | null, pageSize?: number | null) {
    const params: string[] = [];
    if (typeof pageIndex === 'undefined' || pageIndex === null) {
      pageIndex = this.params.pageIndex || 0;
    }
    if (typeof pageSize === 'undefined' || pageSize === null) {
      pageSize = this.params.pageSize || 6;
    }
    params.push(`pageSize=${pageSize}`);
    params.push(`pageIndex=${pageIndex}`);
    return BasePathService.convertPath(`/api/runtime/comment/v1.0/bill-comment/frequentAtUsers?${params.join('&')}`);
  }
  private buildAddCommentParam(id: string, text: string, parentId: string, summary: string, visibility: string, configId: string) {
    if (typeof text === 'undefined') {
      text = this.params.text;
    }
    if (typeof parentId === 'undefined') {
      parentId = this.params.parentId;
    }
    if (typeof visibility === 'undefined') {
      visibility = this.params.visibility;
    }
    return {
      'bill': {
        'billId': id,
        'configId': configId,
        'summary': summary
      },
      'comment': {
        'billId': id,
        'configId': configId,
        'parentId': parentId || null,
        'text': text,
        'visibility': visibility
      }
    }
  }
}
